module.exports = __webpack_public_path__ + "img/m_pic_rule.fc4d8a23.png";